import {MatrixClient, MatrixEvent} from 'matrix-js-sdk';

export const setMessageRead = async (
  matrixClient: MatrixClient,
  matrixEvent: MatrixEvent
): Promise<void> => {
  try {
    await matrixClient.sendReadReceipt(matrixEvent);
  } catch (error) {
    console.error('Error while setting events as read', error);
  }
};
